import { render, staticRenderFns } from "./MainCardSection.vue?vue&type=template&id=f5ac32d6&"
import script from "./MainCardSection.vue?vue&type=script&lang=js&"
export * from "./MainCardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports